import type { Ref } from 'vue'
import type TossPayments from '@/uComponents/order/TossPayments.vue'

/**
 * 결제 버튼 활성/비활성 및 최종 결제 가능 여부를
 * 네이버페이/토스 위젯 상태 기준으로 공통 처리하는 헬퍼
 *
 * - baseValid: 폼/배송지/약관 등 위젯 외 유효성 검사 결과 (true면 기본 조건 통과)
 * - baseInvalid: 위와 반대로, 기본 조건이 깨졌는지 여부
 */
export const usePaymentButtonState = (
  tossPaymentRef: Ref<InstanceType<typeof TossPayments> | null>
) => {
  /**
   * 최종 결제 가능 여부
   * - baseValid가 false면 무조건 false
   * - 네이버페이가 선택된 경우 위젯 준비 여부와 관계없이 true
   * - 그 외에는 토스 위젯 준비 여부(isReadyTossWidget)에 따름
   */
  const canProceedPayment = (baseValid: boolean) => {
    if (!baseValid) return false
    const ref = tossPaymentRef.value
    if (!ref) return false
    if (ref.isSelectNaverPay) return true
    return !!ref.isReadyTossWidget
  }

  /**
   * 버튼 비활성화 여부
   * - baseValid가 false면 무조건 true
   * - 네이버페이가 선택된 경우 위젯 준비 여부와 관계없이 false
   * - 그 외에는 토스 위젯 준비 여부(isReadyTossWidget)에 따름
   */
  const isDisabledByPaymentState = (baseValid: boolean) => {
    if (!baseValid) return true
    const ref = tossPaymentRef.value
    if (!ref) return true
    if (ref.isSelectNaverPay) return false
    return !ref.isReadyTossWidget
  }

  return { canProceedPayment, isDisabledByPaymentState }
}
